const Images = {
    the_carbon_games : require('./the_carbon_games.png'),
    illustration_1 : require('./illustration_1.png'),
    illustration_2 : require('./illustration_2.png'),
    illustration_3 : require('./illustration_3.png'),
    hexagon_illustration : require('./hexagon_illustration.png')
}

export default Images